module.exports = __webpack_public_path__ + "static/media/ic_selection.e441b4dc.svg";